const BASE_URL = "https://dev.distincthealth.com/api";
const TOKEN = "404e725a2b7da700b15e03f2960c57c3e15fb9fe9b3e3d752210d0ffb5349941df5d9148cfe753a8416cd5206ee98c01cf331b4bda0e232a6372cd103689a2d520d6ab4fd0062680c228861e4b9b4cc346d446d3845a6214daa2718b1031fb2f5a27fb6af47a8e2ca5d606d87951a617ec957be9c1c779c7806181a68c68839d";   // same as Flutter

export async function fetchArticles(locale = "en") {
  try {
    const res = await fetch(`${BASE_URL}/articles?locale=${locale}&populate[country]=true`, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });

    if (!res.ok) throw new Error("Failed to fetch articles");

    const json = await res.json();
    return json.data || [];
  } catch (err) {
    console.error("❌ Error fetching articles:", err);
    return [];
  }
}

export async function fetchArticleByDocumentId(id, locale = "en") {
  try {
    const url = `${BASE_URL}/articles/${id}?locale=${locale}&populate=*`;
    console.log("Fetching article from:", url);

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${TOKEN}` },
    });

    console.log("Response status:", res.status);

    if (!res.ok) {
      const errorText = await res.text();
      console.error("API returned error:", res.status, errorText);
      return null;
    }

    const json = await res.json(); // directly parse JSON
    console.log("Parsed JSON:", json);

    return json.data || null;
  } catch (err) {
    console.error("❌ Error fetching article:", err);
    return null;
  }
}

export async function updateArticle(documentId, data, locale = "en") {
  try {
    const res = await fetch(
      `${BASE_URL}/articles/${documentId}?locale=${locale}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({ data }),
      }
    );

    if (!res.ok) throw new Error("Failed to update article");

    const json = await res.json();
    return json.data;
  } catch (err) {
    console.error("❌ Error updating article:", err);
    return null;
  }
}